import { render, staticRenderFns } from "./MyStaticHud.vue?vue&type=template&id=60980975&scoped=true&"
import script from "./MyStaticHud.vue?vue&type=script&lang=js&"
export * from "./MyStaticHud.vue?vue&type=script&lang=js&"
import style0 from "./MyStaticHud.vue?vue&type=style&index=0&id=60980975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60980975",
  null
  
)

export default component.exports